import { Component } from '@angular/core';
import { ParamContext } from '../shared/service/param.context';
import { HELP_MANAGE_ONTOLOGIES } from '../app.constants';

@Component({
    selector: 'jhi-ontology-manager',
    templateUrl: './ontology-manager.component.html',
    styleUrls: ['ontology-manager.scss']
})
export class OntologyManagerComponent {
    protected readonly HELP_MANAGE_ONTOLOGIES = HELP_MANAGE_ONTOLOGIES;

    constructor(
        private paramContext: ParamContext,
    ) {
        this.paramContext.readParams();
    }
}
